<template>
  <Nav v-if="route.path !== '/'"> </Nav>
  <router-view />
  <Footer v-if="ary.indexOf(route.path) >= 0"> </Footer>
  <enFooter v-if="ary1.indexOf(route.path) >= 0"></enFooter>
</template>

<script setup>
import { useRoute } from "vue-router";
import Nav from "@/components/nav.vue";
import Footer from "@/components/footer.vue";
import enFooter from "@/components/enFooter.vue";
let route = useRoute();
let ary = ["/issue", "/detail", "/index","/search"];
let ary1 = ["/enIndex", "/enIssue", "/enDetail", "/enDetail1"];
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

@font-face {
  font-family: "iconfont"; /* Project id 4771142 */
  src: url("//at.alicdn.com/t/c/font_4771142_2ot3vi79tun.woff2?t=1733900581705")
      format("woff2"),
    url("//at.alicdn.com/t/c/font_4771142_2ot3vi79tun.woff?t=1733900581705")
      format("woff"),
    url("//at.alicdn.com/t/c/font_4771142_2ot3vi79tun.ttf?t=1733900581705")
      format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-sousuo:before {
  content: "\e60a";
}

.icon-youjiantou:before {
  content: "\e6e0";
}

.icon-zuojiantou:before {
  content: "\e600";
}
</style>
